import chunk from 'lodash/chunk';
import findIndex from 'lodash/findIndex';
import React from 'react';
import Carousel from 'react-bootstrap/lib/Carousel';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import { makeSelectIsAuthenticated } from '~/containers/AuthProvider/selectors';

@withI18next()
class Bonus extends React.Component {
  constructor(props) {
    super(props);
    this.bonus = [
      { id: 1, file_type: ['jpg', 'png', 'ai'] },
      { id: 2, file_type: ['jpg', 'png', 'ai'] },
      { id: 3, file_type: ['jpg', 'png', 'ai'] },
      { id: 4, file_type: ['jpg', 'png', 'ai'] },
      { id: 5, file_type: ['jpg', 'png', 'ai'] },
      { id: 6, file_type: ['jpg', 'png', 'ai'] },
      { id: 7, file_type: ['jpg', 'png', 'ai'] },
      { id: 8, file_type: ['jpg'] },
      { id: 9, file_type: ['jpg', 'png', 'ai'] },
      { id: 10, file_type: ['jpg'] },
      { id: 11, file_type: ['jpg', 'png', 'ai'] },
      { id: 12, file_type: ['jpg', 'png', 'ai'] },
      { id: 13, file_type: ['jpg', 'png', 'ai'] },
      { id: 14, file_type: ['jpg', 'png', 'ai'] },
      { id: 15, file_type: ['jpg', 'png', 'ai'] },
      { id: 16, file_type: ['jpg', 'png', 'ai'] },
      { id: 17, file_type: ['jpg', 'png', 'ai'] },
      { id: 18, file_type: ['jpg', 'png', 'ai'] },
      { id: 19, file_type: ['jpg', 'ai'] },
      { id: 20, file_type: ['jpg', 'ai'] },
      { id: 29, file_type: ['jpg'] },
      { id: 30, file_type: ['jpg'] },
      { id: 31, file_type: ['jpg'] },
      { id: 32, file_type: ['jpg', 'ai'] },
    ];
    this.state = {
      show: false,
      indx: 0,
      direction: null,
      showModal: false,
    };

    this.getLink = this.getLink.bind(this);
  }

  // componentDidMount() {
  //   setTimeout(() => {
  //     this.setState({ show: true });
  //   }, 3000);
  // }

  toggleBonus() {
    this.setState({ show: !this.state.show });
  }

  handleClose() {
    this.setState({ showModal: false });
  }

  handleShowModal(id) {
    this.setState({ indx: findIndex(this.bonus, ['id', id]), showModal: true });
  }

  handleSelect(index, e) {
    this.setState({ indx: index, direction: e.direction });
  }

  getLink() {
    return this.props.isAuthenticated
      ? `/${this.props.lng}/register-premium`
      : `/${this.props.lng}/login?redirect=register-premium`;
  }

  render() {
    const { t } = this.props;

    const bonus = chunk(this.bonus, 6);
    return (
      <div className={`bonus ${this.state.show ? 'show-bonus' : 'hide-bonus'}`}>
        <div className="row">
          <div className="col-md-12">
            <div className="bonus-icon" role="button">
              <img
                onClick={this.toggleBonus.bind(this)}
                src={`${
                  Config.staticPrefix
                }/static/assets/image/premium/bonus/${Config.getPrefixContent(
                  'present_icon',
                )}.png`}
                width={40}
                height={40}
              />
            </div>
            <div className="bonus-content">
              <h1 className="text-center bonus-title">
                {this.props.t('credit_premium_bonus_title')}
              </h1>
              {/* <p
                className="text-center bonus-note pb20"
                onClick={this.props.onRegisterPremium}
                dangerouslySetInnerHTML={{ __html: t('credit_premium_bonus_note') }}
              /> */}
              <Carousel indicators={false}>
                {bonus.map((bonusChunk, index) => (
                  <Carousel.Item key={index}>
                    <ul>
                      {bonusChunk.map((item, i) => (
                        <li className="text-center" key={i}>
                          <img
                            role="button"
                            onClick={this.handleShowModal.bind(this, item.id)}
                            src={`${Config.staticPrefix}/static/assets/image/premium/bonus/${item.id}/subject.jpg`}
                            alt={this.props.t(
                              `credit_premium_bonus_title${item.id}`,
                            )}
                          />
                          <div className="text-center pt">
                            {this.props.t(
                              `credit_premium_bonus_title${item.id}`,
                            )}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
            <Modal
              bsSize="large"
              show={this.state.showModal}
              onHide={this.handleClose.bind(this)}
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  {this.props.t(
                    `credit_premium_bonus_title${
                      this.bonus[this.state.indx].id
                    }`,
                  )}
                  （ {this.bonus[this.state.indx].file_type.join(', ')} ）
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="modal-bonus">
                  <Carousel
                    indicators={false}
                    activeIndex={this.state.indx}
                    direction={this.state.direction}
                    interval={null}
                    onSelect={this.handleSelect.bind(this)}
                  >
                    {this.bonus.map((bonus, index) => (
                      <Carousel.Item key={index} index={index}>
                        <img
                          className="img-responsive"
                          src={`/static/assets/image/premium/bonus/${bonus.id}/freebieac.jpg`}
                          alt={this.props.t(
                            `credit_premium_bonus_title${bonus.id}`,
                          )}
                        />
                        <img
                          className="img-responsive"
                          src={`/static/assets/image/premium/bonus/${bonus.id}/thumbnail.jpg`}
                          alt={this.props.t(
                            `credit_premium_bonus_title${bonus.id}`,
                          )}
                        />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                </div>
              </Modal.Body>
              {/* <Modal.Footer>
                <div className="text-right">
                  <a href={this.getLink()}>{this.props.t('credit_premium_bonus_link')}</a>
                </div>
              </Modal.Footer> */}
            </Modal>
          </div>
        </div>
        <style jsx global>
          {`
            .bonus {
              position: fixed;
              bottom: 0;
              height: 350px;
              z-index: 10;
              width: 100%;
            }
            .bonus .row li:hover {
              background-color: transparent;
            }

            .bonus.show-bonus {
              left: 0;
              right: 0;
              -webkit-transition: all 0.5s ease-in-out;
              -moz-transition: all 0.5s ease-in-out;
              -ms-transition: all 0.5s ease-in-out;
              -o-transition: all 0.5s ease-in-out;
              transition: all 0.5s ease-in-out;
            }

            .bonus.hide-bonus {
              left: calc(100% - 40px);
              right: -100%;
              -webkit-transition: all 0.5s ease-in-out;
              -moz-transition: all 0.5s ease-in-out;
              -ms-transition: all 0.5s ease-in-out;
              -o-transition: all 0.5s ease-in-out;
              transition: all 0.5s ease-in-out;
            }

            .bonus .bonus-content {
              background-color: rgba(0, 0, 0, 0.85);
              color: #ffffff;
              height: 350px;
            }

            .bonus .bonus-icon {
              float: left;
              width: 40px;
            }

            .bonus .bonus-content {
              float: left;
              width: calc(100% - 40px);
            }

            .bonus .bonus-content .bonus-title {
              font-size: 26px;
            }

            .bonus .bonus-content .bonus-note {
              font-size: 15px;
            }
            .bonus .bonus-content .bonus-note a {
              color: white;
            }

            .bonus .bonus-content .carousel.slide {
              width: 70%;
              margin-left: 15%;
            }

            .bonus .bonus-content ul {
              padding: 0;
              margin: 0;
              width: 100%;
              overflow: hidden;
            }

            .bonus .bonus-content ul li {
              float: left;
              width: calc(100% / 6);
              list-style: none;
              padding: 0 14px;
            }

            .bonus .bonus-content ul li img {
              max-width: 165px;
              width: 100%;
            }

            .bonus .bonus-content ul li span {
              font-size: 12px;
            }

            .modal-bonus .carousel-control.left,
            .bonus-content .carousel-control.left {
              left: -15%;
            }

            .modal-bonus .carousel-control.right,
            .bonus-content .carousel-control.right {
              right: -15%;
            }

            .modal-bonus .carousel-control,
            .modal-bonus .carousel-control:focus,
            .modal-bonus .carousel-control:hover,
            .bonus-content .carousel-control,
            .bonus-content .carousel-control:focus,
            .bonus-content .carousel-control:hover {
              background-image: none;
            }

            .modal-bonus .carousel-control .glyphicon {
              top: 250px;
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  isAuthenticated: makeSelectIsAuthenticated(),
});
export default connect(mapStateToProps)(Bonus);
